import { put } from '..';

const editMyProfile = (
  email: string,
  firstName: string,
  lastName: string,
) => put(
  'users/me',
  {
    firstName,
    lastName,
  },
);

export default editMyProfile;
